import React from 'react';
import AsyncPage from './index';
import {Route} from 'react-router-dom';

export default [
  <Route key="/business/app/sign-in" path="business/app/sign-in" element={<AsyncPage />} />,
];
